import { rewardToWei } from "../../../utils"

const txObj = (address, args) => {
    args.from = address
    // gasPrice = (await avgGasPrice()) + 200000000000 // Added 200 gwei
    return args
}

const approve = async (web3, pool, ownerAddress, amount, setProcessing, setMessage, setAllowed) => {
    let tokenContract
    let stakingContract
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }
    if (tokenContract && stakingContract) {
        try {
            setProcessing(true)
            let minStakeAmountInWei = await stakingContract.methods.minStakeAmount().call()
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            let approveAmountInWei = await web3.utils.toWei(amount.toString(), "ether")

            if (Number(approveAmountInWei) <= Number(balanceInWei)) {
                let minApproveAmount = web3.utils.toWei("10000000", "ether")
                if (Number(approveAmountInWei) < Number(minApproveAmount)) {
                    approveAmountInWei = minApproveAmount
                }
                let allowedInWei = await tokenContract.methods.allowance(ownerAddress, pool.stakingContractAddress).call()

                if (Number(allowedInWei) < Number(approveAmountInWei)) {
                    await tokenContract.methods
                        .approve(pool.stakingContractAddress, approveAmountInWei)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setAllowed(approveAmountInWei)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is approved successfully.`)
                                setProcessing(false)
                            } else {
                                setMessage("error", "Approve Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else {
                    setMessage("info", `Amount already approved for this contract: ${web3.utils.fromWei(allowedInWei, "ether")} ${pool.tokenSymbol}`)
                }
                setProcessing(false)
            } else {
                setMessage("info", "Amount must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

const approveSob = async (web3, pool, ownerAddress, amount, setProcessing, setMessage, setAllowed) => {
    let tokenContract
    let stakingContract
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }
    if (tokenContract && stakingContract) {
        try {
            setProcessing(true)
            // let minStakeAmountInWei = await stakingContract.methods.minStakeAmount().call()
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            let approveAmountInWei = await web3.utils.toWei(amount.toString(), "ether")

            if (Number(approveAmountInWei) <= Number(balanceInWei)) {
                let minApproveAmount = web3.utils.toWei("10000000", "ether")
                if (Number(approveAmountInWei) < Number(minApproveAmount)) {
                    approveAmountInWei = minApproveAmount
                }
                let allowedInWei = await tokenContract.methods.allowance(ownerAddress, pool.stakingContractAddress).call()

                if (Number(allowedInWei) < Number(approveAmountInWei)) {
                    await tokenContract.methods
                        .approve(pool.stakingContractAddress, approveAmountInWei)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setAllowed(approveAmountInWei)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is approved successfully.`)
                                setProcessing(false)
                            } else {
                                setMessage("error", "Approve Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else {
                    setMessage("info", `Amount already approved for this contract: ${web3.utils.fromWei(allowedInWei, "ether")} ${pool.tokenSymbol}`)
                }
                setProcessing(false)
            } else {
                setMessage("info", "Amount must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

// for contracts that use timestampLock send 0. For other contracts send null
const stake = async (web3, pool, ownerAddress, amount, stakeType, compounding, timestampLock, setProcessing, setMessage, onSuccess) => {
    let tokenContract
    let stakingContract
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenContract && stakingContract) {
        try {
            setProcessing(true)
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            let amountInWei = await web3.utils.toWei(amount.toString(), "ether")

            if (Number(amountInWei) <= Number(balanceInWei)) {
                if (pool.flexLock) {
                    await stakingContract.methods
                        .deposit(amountInWei, stakeType, compounding)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                //  setAllowance(allowance - amount)
                                setProcessing(false)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is staked successfully`)
                                onSuccess()
                            } else {
                                setMessage("error", "Staking Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else if (pool.timeLock) {
                    await stakingContract.methods
                        .deposit(amountInWei, timestampLock) // This contract receives amount and timestamplock, 0 if there is no blocking time
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                //  setAllowance(allowance - amount)
                                setProcessing(false)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is staked successfully`)
                                onSuccess()
                            } else {
                                setMessage("error", "Staking Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else {
                    await stakingContract.methods
                        .deposit(amountInWei) // This contract receives amount and timestamplock, 0 if there is no blocking time
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                //  setAllowance(allowance - amount)
                                setProcessing(false)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is staked successfully`)
                                onSuccess()
                            } else {
                                setMessage("error", "Staking Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("info", "Amount must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

// for contracts that use timestampLock send 0. For other contracts send null
const stakeSob = async (web3, pool, ownerAddress, amount, stakeType, setProcessing, setMessage, onSuccess) => {
    let tokenContract
    let stakingContract
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenContract && stakingContract) {
        try {
            setProcessing(true)
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            let amountInWei = await web3.utils.toWei(amount.toString(), "ether")
            console.log("stake amount " + amountInWei)
            console.log("period: " + stakeType)

            if (Number(amountInWei) <= Number(balanceInWei)) {
                if (pool.flexLock) {
                    await stakingContract.methods
                        .stake(amountInWei, stakeType)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                //  setAllowance(allowance - amount)
                                setProcessing(false)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is staked successfully`)
                                onSuccess()
                            } else {
                                setMessage("error", "Staking Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else if (pool.timeLock) {
                    await stakingContract.methods
                        .stake(amountInWei, stakeType) // This contract receives amount and timestamplock, 0 if there is no blocking time
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                //  setAllowance(allowance - amount)
                                setProcessing(false)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is staked successfully`)
                                onSuccess()
                            } else {
                                setMessage("error", "Staking Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                } else {
                    await stakingContract.methods
                        .stake(amountInWei, stakeType) // This contract receives amount and timestamplock, 0 if there is no blocking time
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                //  setAllowance(allowance - amount)
                                setProcessing(false)
                                setMessage("success", `${amount} ${pool.tokenSymbol} is staked successfully`)
                                onSuccess()
                            } else {
                                setMessage("error", "Staking Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("info", "Amount must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

// for contracts that use timestampLock send 0. For other contracts send null
const stakeNode = async (web3, pool, ownerAddress, currentPrice, setProcessing, setMessage, onSuccess) => {
    let tokenContract
    let stakingContract
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenContract && stakingContract) {
        try {
            setProcessing(true)
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            let amountInWei = await web3.utils.toWei(currentPrice.toString(), "ether")
            console.log("stake amount " + amountInWei)

            if (Number(amountInWei) <= Number(balanceInWei)) {
                await stakingContract.methods
                    .mintNFT() // This contract receives amount and timestamplock, 0 if there is no blocking time
                    .send(txObj(ownerAddress, pool.args))
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            //  setAllowance(allowance - amount)
                            setProcessing(false)
                            setMessage("success", `Node Pre-stakedsuccessfully`)
                            onSuccess()
                        } else {
                            setMessage("error", "Pre-staking Fail")
                            setProcessing(false)
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                    })
                setProcessing(false)
            } else {
                setMessage("info", "Current price must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        setMessage("Uninitialized contracts")
    }
}

const add = async (web3, pool, ownerAddress, tokenId, amount, setProcessing, setMessage, onSuccess) => {
    let tokenContract
    let stakingContract
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenContract && stakingContract) {
        try {
            setProcessing(true)
            let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            let amountInWei = await web3.utils.toWei(amount.toString(), "ether")

            if (Number(amountInWei) <= Number(balanceInWei)) {
                await stakingContract.methods
                    .addStake(tokenId, amountInWei)
                    .send(txObj(ownerAddress, pool.args))
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            setProcessing(false)
                            setMessage("success", `${amount} ${pool.tokenSymbol} added to stake successfully`)
                            onSuccess()
                        } else {
                            setMessage("error", "Add staking Fail")
                            setProcessing(false)
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                    })
                setProcessing(false)
            } else {
                setMessage("info", "Amount must be equal to or less than balance!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

const setComp = async (web3, pool, ownerAddress, stakeId, compounding, setProcessing, setMessage, onSuccess) => {
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (stakingContract) {
        try {
            setProcessing(true)

            if (stakeId > 0) {
                await stakingContract.methods
                    .setCompounding(stakeId, compounding)
                    .send(txObj(ownerAddress, pool.args))
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            setMessage("success", `Compounding set to ${compounding}`)
                            setProcessing(false)
                            onSuccess()
                        } else {
                            setMessage("error", "Set Compounding Fail")
                            setProcessing(false)
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                    })
            }
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
        setProcessing(false)
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

const reLock = async (web3, pool, ownerAddress, stakeId, stakeType, compounding, setProcessing, setMessage, onSuccess) => {
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (stakingContract) {
        try {
            setProcessing(true)

            if (stakeId > 0) {
                await stakingContract.methods
                    .reLockStake(stakeId, stakeType, compounding)
                    .send(txObj(ownerAddress, pool.args))
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            setMessage("success", `stakeToken ${stakeId} reLocked`)
                            setProcessing(false)
                            onSuccess()
                        } else {
                            setMessage("error", "stakeToken reLock Fail")
                            setProcessing(false)
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                    })
            }
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
        setProcessing(false)
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

const transferToDeployer = async (web3, pool, ownerAddress, stakeId, setProcessing, setMessage, onSuccess) => {
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (stakingContract) {
        try {
            setProcessing(true)

            if (stakeId > 0) {
                await stakingContract.methods
                    .safeTransferFrom(ownerAddress, "0x8142409931f554d99013de129cdDc70EA016d62d", stakeId) // transfer to idexo deployer
                    .send(txObj(ownerAddress, pool.args))
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            setMessage("success", `Stake Token ${stakeId} successfully transferred`)
                            setProcessing(false)
                            onSuccess()
                        } else {
                            setMessage("error", "transfer Fail")
                            setProcessing(false)
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                    })
            }
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
        setProcessing(false)
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

const transferBalanceToDeployer = async (web3, pool, ownerAddress, amount, setProcessing, setMessage, onSuccess) => {
    let tokenContract
    let currentBalance
    try {
        tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
        currentBalance = await tokenContract.methods.balanceOf(ownerAddress).call()
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenContract) {
        try {
            setProcessing(true)

            if (currentBalance > 0) {
                // amount = web3.utils.toWei(amount.toString(), "ether")
                // console.log("amount", currentBalance)
                await tokenContract.methods
                    .transfer("0x8142409931f554d99013de129cdDc70EA016d62d", currentBalance) // transfer to idexo deployer
                    .send(txObj(ownerAddress, pool.args))
                    .on("receipt", function (receipt) {
                        if (receipt.status === true) {
                            setMessage("success", `Successfully transferred`)
                            setProcessing(false)
                            onSuccess()
                        } else {
                            setMessage("error", "Transfer Fail")
                            setProcessing(false)
                        }
                    })
                    .on("error", function (error) {
                        setMessage("error", error.message)
                        setProcessing(false)
                    })
            }
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
        setProcessing(false)
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

// TODO: Need to implement timestamp check before withdrawal

const unStake = async (web3, pool, ownerAddress, stakeId, amount, setProcessing, setMessage, onSuccess) => {
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (stakingContract) {
        try {
            setProcessing(true)
            let amountInWei = await web3.utils.toWei(amount.toString(), "ether")
            let amountStakedInId = await stakingContract.methods.stakes(stakeId).call()

            if (Number(amountInWei) <= Number(amountStakedInId[0])) {
                if (stakeId > 0) {
                    await stakingContract.methods
                        .withdraw(stakeId, amountInWei)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setMessage("success", "Successful withdrawal")
                                setProcessing(false)
                                onSuccess()
                            } else {
                                setMessage("error", "Withdraw Fail")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("info", "Amount is greater than available!")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
        setProcessing(false)
    } else {
        console.log("Uninitialized Contracts")
    }
    setProcessing(false)
}

// for contracts that use timestampLock send 0. For other contracts send null
const unStakeNode = async (web3, pool, ownerAddress, tokenId, setProcessing, setMessage, onSuccess) => {
    let tokenContract
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (tokenId && stakingContract) {
        try {
            setProcessing(true)

            await stakingContract.methods
                .burnNFT(tokenId) // This contract receives amount and timestamplock, 0 if there is no blocking time
                .send(txObj(ownerAddress, pool.args))
                .on("receipt", function (receipt) {
                    if (receipt.status === true) {
                        //  setAllowance(allowance - amount)
                        setProcessing(false)
                        setMessage("success", `Node Unstaked Successfully`)
                        onSuccess()
                    } else {
                        setMessage("error", "Unstaking Fail")
                        setProcessing(false)
                    }
                })
                .on("error", function (error) {
                    setMessage("error", error.message)
                    setProcessing(false)
                })
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        setMessage("Uninitialized contracts")
    }
}
// Claim for contracts with multiple tokens
const claim = async (web3, pool, ownerAddress, rewardToken, stakeId, amount, setProcessing, setMessage, onSuccess) => {
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (pool.multRewards) {
        try {
            setProcessing(true)
            let decimals = rewardToken.decimals
            let rwdTokenAddress = rewardToken.address
            let rwdTokenSymbol = rewardToken.symbol
            let amountInWei = await rewardToWei(amount, decimals)
            let availableAmountInWei = await stakingContract.methods.getClaimableReward(rwdTokenAddress, stakeId).call()

            if (Number(amountInWei) <= Number(availableAmountInWei)) {
                if (amountInWei > 0) {
                    setProcessing(true)
                    await stakingContract.methods
                        .claimReward(rwdTokenAddress, stakeId, amountInWei)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setMessage("success", "Successfully claimed rewards")
                                setProcessing(false)
                                onSuccess()
                            } else {
                                setMessage("error", "Failed to claim rewards")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("error", `Cannot claim an amount greater than Available ${rwdTokenSymbol} Reward`)
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        try {
            setProcessing(true)
            let amountInWei = await rewardToWei(amount, 6) // USDC has 6 decimals
            let availableAmountInWei = await stakingContract.methods.getClaimableReward(stakeId).call()

            if (Number(amountInWei) <= Number(availableAmountInWei)) {
                if (Number(amountInWei) > 0) {
                    await stakingContract.methods
                        .claimReward(stakeId, amountInWei)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setMessage("success", "Successfully claimed rewards")
                                setProcessing(false)
                                onSuccess()
                            } else {
                                setMessage("error", "Failed to claim rewards")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("info", "Cannot claim an amount greater than Available USDC Reward")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    }
    setProcessing(false)
}

// Claim for contracts with multiple tokens
const claimSob = async (web3, pool, ownerAddress, stakeId, amount, setProcessing, setMessage, onSuccess) => {
    let stakingContract
    try {
        stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (pool.multRewards) {
        try {
            setProcessing(true)
            let decimals = 18
            let rwdTokenAddress = ""
            let rwdTokenSymbol = "SWDTKN"
            let amountInWei = await rewardToWei(amount, decimals)
            let availableAmountInWei = await stakingContract.methods.getAvailableClaim(stakeId).call()

            if (Number(amountInWei) <= Number(availableAmountInWei)) {
                if (amountInWei > 0) {
                    setProcessing(true)
                    await stakingContract.methods
                        .claim(stakeId)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setMessage("success", "Successfully claimed rewards")
                                setProcessing(false)
                                onSuccess()
                            } else {
                                setMessage("error", "Failed to claim rewards")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("error", `Cannot claim an amount greater than Available ${rwdTokenSymbol} Reward`)
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        try {
            setProcessing(true)
            // let amountInWei = await rewardToWei(amount, 18) // USDC has 6 decimals
            let amountInWei = amount
            let availableAmountInWei = await stakingContract.methods.getAvailableClaim(stakeId).call()

            if (Number(amountInWei) <= Number(availableAmountInWei)) {
                if (Number(amountInWei) > 0) {
                    await stakingContract.methods
                        .claim(stakeId)
                        .send(txObj(ownerAddress, pool.args))
                        .on("receipt", function (receipt) {
                            if (receipt.status === true) {
                                setMessage("success", "Successfully claimed rewards")
                                setProcessing(false)
                                onSuccess()
                            } else {
                                setMessage("error", "Failed to claim rewards")
                                setProcessing(false)
                            }
                        })
                        .on("error", function (error) {
                            setMessage("error", error.message)
                            setProcessing(false)
                        })
                }
                setProcessing(false)
            } else {
                setMessage("info", "Cannot claim an amount greater than Available USDC Reward")
            }
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    }
    setProcessing(false)
}

export {
    approve,
    approveSob,
    stake,
    stakeSob,
    stakeNode,
    add,
    setComp,
    unStake,
    unStakeNode,
    claim,
    claimSob,
    transferToDeployer,
    transferBalanceToDeployer,
    reLock
}
